const strings = {
  farm: 'Propriedades',
}

export default strings
